import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@mui/material';
import MobileCard from './MobileCard';
import { USDollar } from '../../utilities/Constants';
import { trimDate } from '../../utilities/DateFormat';

export default function ApprovalsPendingPaymentCardMobile(props) {
    const { approvalPendingPayment, showRevoke } = props;

    return (
        <MobileCard
            title={`Unit ${approvalPendingPayment.storageUnit.name}`}
            subtitle={`${approvalPendingPayment.appUser.firstName} ${approvalPendingPayment.appUser.lastName}`}
            status={{ label: 'Awaiting payment', color: 'warning' }}
            fields={[
                { label: 'Email', value: approvalPendingPayment.appUser.username },
                { label: 'Price', value: USDollar.format(approvalPendingPayment.storageUnit.price) },
                { label: 'Move in', value: trimDate(approvalPendingPayment.moveInDate) },
                { label: 'Token', value: approvalPendingPayment.token },
            ]}
            actions={
                <Button variant={'outlined'} color={'error'} onClick={showRevoke}>
                    Revoke Approval
                </Button>
            }
        />
    );
}

ApprovalsPendingPaymentCardMobile.propTypes = {
    approvalPendingPayment: PropTypes.object,
    showRevoke: PropTypes.func,
};
